import React, { useState, useEffect } from 'react';
import { MonkeyLoader } from '../MonkeyLoader';
import './PageLoader.css';

/**
 * PageLoader - Loading component for lazy-loaded pages
 *
 * Used as a Suspense fallback when loading route components asynchronously.
 * Shows nothing for the first second (fast loads feel instant),
 * then shows MonkeyLoader if still loading (slow connection feedback).
 */
export const PageLoader: React.FC = () => {
  const [showMonkey, setShowMonkey] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowMonkey(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!showMonkey) return null;

  return <MonkeyLoader />;
};

export default PageLoader;
